import { Component, OnInit,AfterViewInit , ViewChild, ElementRef } from '@angular/core';
import { UserService } from "../services/user/user.service";
import {Chart} from 'chart.js';
@Component({
  selector: 'app-wallet',
  templateUrl: './wallet.component.html',
  styleUrls: ['./wallet.component.css']
})
export class WalletComponent implements AfterViewInit {
  balanceData=[];
  dataPortfeuille:any
  @ViewChild('balance') balancesAge: ElementRef;
  constructor(private userService:UserService) { }
  ngAfterViewInit(): void {
    this.userService.getProtfeuille().subscribe(res =>{
      for (let i = 1; i <= 5; i++) {
        this.balanceData.push(res["dataFacture"]["g"+i]);
      }
      this.dataPortfeuille = res["data"]
      const labels = [
        '+90 j',
        '61 - 90 j',
        '31 - 60 j',
        '0 - 30 j',
        'Non échu',
      ];

      const data = {
        labels: labels,
        datasets: [{
        label: 'Total',
        backgroundColor: '#c80217',
        borderColor: '#000',
        data: this.balanceData.reverse(),
        }]
      }
      const chart1 = new Chart(
      this.balancesAge.nativeElement,{type: "bar",data: data} );
    })
  }

}
